import React from "react";
import { Link } from "react-router-dom";
import PageLayout from "./PageLayout";
import { APP_STORE_URL, IMG } from "../data/mock";

export default function AboutPage() {
  return (
    <PageLayout
      title="About Life With Abba"
      subtitle="A digital secret place where your everyday life meets the heart of your Heavenly Father."
    >
      <div className="max-w-3xl mx-auto px-5 py-14 md:py-20">
        <div className="flex justify-center mb-10">
          <img src={IMG.miniLogo} alt="" className="h-14 w-auto" />
        </div>

        <div className="space-y-6 font-serif-body text-[#444] text-[17px] leading-[1.9]">
          <p>
            We share nearly everything online — our meals, our victories, and our
            quiet thoughts at midnight. <strong className="text-[#68c2d5]">Life With Abba</strong>{" "}
            was born from a simple question: what if the One who loves you most
            was waiting to hear about those very same moments?
          </p>
          <p>
            Rooted in Galatians 4:6 — “God hath sent forth the Spirit of his Son
            into your hearts, crying, Abba, Father” — our mission is to help you
            build a closer, more social relationship with God. The word{" "}
            <strong className="text-[#68c2d5]">Abba</strong> is intimate; it is the
            language of a child who trusts completely.
          </p>
          <p>
            The app brings the familiar features of modern social platforms —
            photos, videos, scripture, writing, voice, and moods — but reimagines
            them for an audience of One. While others won’t see your content, we
            believe Abba engages your heart and mind as you share life with Him,
            “social media style.”
          </p>
          <p>
            Life With Abba is owned and operated by NexLev Solutions, LLC. It’s
            our hope and prayer that, through daily moments shared with Him, you
            grow ever closer to your Heavenly Father.
          </p>
        </div>

        <div className="mt-12 flex flex-wrap gap-3">
          <a
            href={APP_STORE_URL}
            target="_blank"
            rel="noreferrer"
            className="bg-[#0f9fbc] hover:bg-[#008da9] text-white font-serif-body px-6 py-3 rounded-[4px] transition-colors"
          >
            Get The iOS App
          </a>
          <Link
            to="/contact"
            className="border border-[#0f9fbc] text-[#0f9fbc] hover:bg-[#0f9fbc] hover:text-white font-serif-body px-6 py-3 rounded-[4px] transition-colors"
          >
            Contact Us
          </Link>
        </div>
      </div>
    </PageLayout>
  );
}
